'use client';

import { format, isSameDay, isToday } from 'date-fns';
import { getWeekStripDays } from '@/app/(main)/calendar/utils/calendarMobileGrid';
import { cn } from '@/utils/сn';

type CalendarMobileWeekStripProps = {
  selectedDate: Date;
  onSelectDate: (date: Date) => void;
};

export function CalendarMobileWeekStrip({ selectedDate, onSelectDate }: CalendarMobileWeekStripProps) {
  const weekDays = getWeekStripDays(selectedDate);

  return (
    <div className="pb-1 md:hidden">
      <div className="grid grid-cols-7">
        {weekDays.map((day, index) => {
          const isSelected = isSameDay(day, selectedDate);
          const isTodayDate = isToday(day);
          const isLastDay = index === weekDays.length - 1;

          return (
            <div className="flex items-center justify-center h-11" key={day.toISOString()}>
              <button
                type="button"
                onClick={() => onSelectDate(day)}
                className={cn('h-full w-full flex flex-col gap-0.5 items-center justify-center', {
                  'rounded-[5px] bg-blue-300 mx-1 my-0.5 text-white': isSelected,
                })}
                aria-pressed={isSelected}
                aria-label={format(day, 'EEEE, MMMM d')}
              >
                <span
                  className={cn('text-xs font-normal font-inter text-grey-700', {
                    'text-white': isSelected,
                  })}
                >
                  {format(day, 'EEE')}
                </span>
                <span
                  className={cn(
                    'flex items-center justify-center text-sm font-medium font-inter',
                    !isSelected && isTodayDate && 'bg-blue-300 font-medium text-white rounded-full h-5 w-5',
                    !isSelected && !isTodayDate && 'text-grey-700'
                  )}
                >
                  {format(day, 'd')}
                </span>
              </button>
              {!isLastDay && <div className="w-0.5 h-full bg-grey-200" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}